import { render, staticRenderFns } from "./LabelStatus.vue?vue&type=template&id=a936608c&"
import script from "./LabelStatus.vue?vue&type=script&lang=ts&"
export * from "./LabelStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports